module.exports = __webpack_public_path__ + "static/media/15-8.831adb3f.mp3";